<div class="d-flex align-items-center border-bottom pb-1">
  <div class="flex-grow-1 lh-1">
    <div>
      <strong class="text-primary">{{ device()?.name }}</strong>

      <button type="button"
              id="toggle-app-lock-edit-mode"
              class="btn btn-outline-secondary no-hover-bg border-0 px-1 py-0 mx-1"
              (click)="editName()">
        <fa-icon [icon]="['fas', 'pencil-alt']"></fa-icon>
      </button>

      @if (displayDeviceNameOverride()) {
        <span class="text-secondary">{{ device()?.deviceNameOverride }}</span>
      }
    </div>
    <small class="font-monospace">{{ device()?.serialNumber }}</small>
  </div>
  <div class="small text-end line-height-1">
    {{ device()?.productName }}<br />
    <small>({{ device()?.model }})</small>
  </div>
  <fa-icon [icon]="['fab', 'apple']"
           size="lg"
           class="ms-3"></fa-icon>
</div>
<div class="small pt-2"><strong>Operating system</strong></div>
<div class="row g-0">
  <div class="col-auto small">
    <span class="align-middle">Version: {{ device()?.osVersion }}</span>
    @if (!isAtLatestAllowedOsVersion()) {
      <fa-icon [icon]="['fas', 'exclamation-triangle']"
               title="Not at latest allowed OS version"
               class="ms-1 text-warning align-middle"></fa-icon>

      <button class="btn btn-sm btn-outline-primary border-0 align-middle"
              (click)="callUpdate($safeNavigationMigration(device()?.udid))">
        <fa-icon icon="arrow-alt-circle-up"></fa-icon>
      </button>
    }
  </div>
  @if (device()?.osUpdates?.length > 0) {
    <div class="col-auto ms-auto small pt-1 row g-0">
      <span class="col-auto pe-1">Updates: </span>
      @for (update of device()?.osUpdates; track update) {
        <span class="col">
          <span>{{ update.productName }} {{ update.version }}</span>
          @if (update.isCritical) {
            <fa-icon [icon]="['fas', 'exclamation']"
                     title="Critical update"></fa-icon>
          }
          @if (update.restartRequired) {
            <fa-icon [icon]="['fas', 'redo']"
                     title="Restart required"></fa-icon>
          }
        </span>
      }
    </div>
  }
</div>
<div class="small pt-2"><strong>Applications</strong></div>
<div class="small row g-0 pb-1">
  @for (application of device()?.managedApplications; track application) {
    <div class="w-100 mb-1"></div>
    <div class="col-auto line-height-1 align-middle">
      <p class="m-0">
        {{ application.name }} ({{ application.version }}
        @if (!application.isConfiguredVersion) {
          <fa-icon class="ms-1 text-warning"
                   [icon]="['fas', 'exclamation-triangle']"
                   title="Not the configured version"></fa-icon>
        }
        ) <br />
        <small>{{ application.identifier }}</small>
      </p>
    </div>
    <div class="col-auto">
      @if (!application.isLocked) {
        <button class="btn btn-outline-primary border-0"
                (click)="callLock($safeNavigationMigration(device()?.udid), application)">
          <fa-icon [icon]="['fas', 'lock-open']"></fa-icon>
        </button>
      } @else {
        <button class="btn btn-outline-primary border-0"
                (click)="callUnlock($safeNavigationMigration(device()?.udid), application)">
          <fa-icon [icon]="['fas', 'lock']"></fa-icon>
        </button>
      }
    </div>
  }
  @if (!device()?.managedApplications || device()?.managedApplications?.length === 0) {
    <div class="col-auto line-height-1"
         i18n>No managed applications.</div>
  }
</div>